// extracted by mini-css-extract-plugin
var _1 = "TextWithIcon-module__animateUploadProgressBarWidth--IjARH";
var _2 = "TextWithIcon-module__animatedBackground--vh40Z";
var _3 = "TextWithIcon-module__iconContainer--xMYXW";
var _4 = "TextWithIcon-module__multiLine--oKuUV";
var _5 = "TextWithIcon-module__singleLine--T5edZ";
var _6 = "TextWithIcon-module__textContainer--dQ88R";
var _7 = "TextWithIcon-module__truncate--ya7oX";
var _8 = "TextWithIcon-module__wrap--urzMZ";
var _9 = "TextWithIcon-module__wrappingGroup--decR3";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "iconContainer", _4 as "multiLine", _5 as "singleLine", _6 as "textContainer", _7 as "truncate", _8 as "wrap", _9 as "wrappingGroup" }
